import { StyledDailyBonusBadge } from '../style';
import ActionButton from '../../ActionButton';
import { EFontWeights } from '../../Helper/enums';
import { DailyBonusBadgeProps } from '../types';
import '../style.scss';


const DailyBonusPopupBadge = ({
    title,
    titleWeight = EFontWeights.Bold,
    titleSize = '24px',
    badgeCoverImage,
    borderColor,
    borderWidth,
    font,
    timer,
    onClickBadge,
    offerId
}: DailyBonusBadgeProps) => {

    return (
        <StyledDailyBonusBadge
            titleWeight={titleWeight}
            titleSize={titleSize}
            badgeCoverImage={badgeCoverImage}
            borderWidth={borderWidth}
            borderColor={borderColor || {colorOne: "#ffffff"}}
            timer={timer}
        >
            <div className="daily-bonus-badge-banner" onClick={()=> onClickBadge(offerId)}>
                <div className='daily-bonus-badge-banner__content'>
                    <h2 className="daily-bonus-badge-banner__title">{title}</h2>
                    <ActionButton
                        className="daily-bonus-badge-banner__action-button"
                        text={timer || ""}
                        borderRadius={'7px'}
                        width={'56px'}
                        textColor='black'
                        font={font}
                        fontWeight='600'
                    />
                </div>
            </div>
        </StyledDailyBonusBadge>
    );
};

export default DailyBonusPopupBadge;
